import { render, staticRenderFns } from "./RecordingPreview.vue?vue&type=template&id=1198780a&"
import script from "./RecordingPreview.vue?vue&type=script&lang=js&"
export * from "./RecordingPreview.vue?vue&type=script&lang=js&"
import style0 from "./RecordingPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports